<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="520px"
    :before-close="() => (visible = false)"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form @submit.native.prevent class="course-title-editor" ref="formRef" :model="formData" :rules="formRules">
      <el-form-item label="课题名称">
        <el-input placeholder="请输入课题名称" :maxlength="100" v-model="formData.titleVal" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="handle">
        <span>确 定</span>
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      formData: {
        titleVal: ''
      },
      formRules: {
        titleVal: [{ required: true, message: '请输入课题名称', trigger: 'change' }]
      }
    };
  },
  props: {
    title: {
      type: String,
      required: true
    },
    show: {
      type: Boolean,
      default: false
    },
    defaultTitleVal: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit('update:show', val);
      }
    }
  },
  created() {
    this.formData.titleVal = this.defaultTitleVal;
  },
  methods: {
    async handle() {
      const pass = await new Promise(resolve => this.$refs.formRef.validate(resolve));
      if (!pass) {
        return;
      }
      this.$emit('confirm', this.formData.titleVal);
    }
  }
};
</script>

<style lang="scss" scoped>
.course-title-editor {
}
</style>
